import Image from "next/image";

import { DogLogoIcon } from "@/assets/icons/general/DogLogo";
import mainBackgroundImage from "@/assets/images/home/bg1.png";
import { Typography } from "@/components/ui/text/Typography/Typography";

const AppDisabled = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div className="absolute top-0 left-0 h-full w-full items-center justify-center">
        <Image
          src={mainBackgroundImage}
          alt="background"
          fill
          className="object-cover"
        />
      </div>
      <div className="z-10 m-auto h-auto w-[600px] max-w-[100vw] rounded-xl shadow-4 drop-shadow-lg">
        <div className="relative flex h-full w-full flex-col items-center justify-center rounded-t-xl">
          <div className="absolute top-0 flex dm:h-[200px] h-[100px] max-h-full w-full shrink-0 grow overflow-hidden rounded-t-xl" />
          <DogLogoIcon className="z-10 h-56 w-56" />
        </div>
        <div className="flex flex-col items-center gap-3 rounded-b-xl bg-secondary-300 p-8">
          <Typography
            size="h3"
            variant="prominent-1"
            className="text-secondary-500"
          >
            Website is currently under development.
          </Typography>
        </div>
        <div id="clerk-captcha" />
      </div>
    </div>
  );
};

export default AppDisabled;
